/**
 * Import constants
 */
import { GET_EMAILS_DATA, GET_EMAILS_DATA_PENDDING, GET_EMAILS_DATA_ERROR } from '../actions/constants';

/**
 * Initial state
 */
const initialState = {
	loading: true,
	data: [],
	error: null
};

/**
 * Bounced reducer
 * @param {*} state
 * @param {*} action
 */
export const emailTemplateReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_EMAILS_DATA_PENDDING:
			return {
				...state,
				loading: true
			};
		case GET_EMAILS_DATA:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null
			};
		case GET_EMAILS_DATA_ERROR:
			return {
				...state,
				loading: true,
				error: action.payload
			};
		default:
			return state;
	}
};
